// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';

const requiredPart = t.interface({
  id: PositiveIntegerSchema,
  name: t.string,
});

export const PaymentCodeSchema = excess(requiredPart);

export interface PaymentCode extends t.TypeOf<typeof PaymentCodeSchema> {}
